<template>
   <div class="popBg animate__animated animate__zoomIn" v-if="popShow" @click.stop="$emit('hiddlen')">
    <div class="popContent animate__animated animate__zoomIn" @click.stop="hiddlen1">
      <h3>{{title}}</h3>
      <div class="popInfo"><slot></slot></div>
      <div class="close" @click.stop="$emit('hiddlen')">×</div>
    </div>
   </div>
</template>
<script>
import { ref, onMounted } from "vue";

export default {
  name: "baseBar",
  props:['title','popShow'],
  setup(props) {

    onMounted(() => {
     
      
    });
    function hiddlen(){

    }
    return {
      hiddlen
    };
  },
};

</script>
<style lang="less" scoped>
    .popBg{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0,0,0,.5);
      z-index: 12;
      .popContent{
        width: 1192px;
        height: 748px;
        background: url("../assets/img/tc.png") no-repeat;
        background-size: 100% 100%!important;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -374px;
        margin-left: -596px;
        display: flex;
        flex-direction: column;
        padding-bottom: 50px;

        h3{
          font-size: 26px;
          color: #fff;
          line-height: 60px;
          padding: 10px 0 0;
        }
        .popInfo{
          width: 90%;
          flex: 1;
          margin-left: 5%;
          margin-top: 10px;
        }
        .close{
          color: rgba(255,255,255,.8);
          font-size: 36px;
          position: absolute;
          top: 20px;
          right: 26px;
          cursor: pointer;
        }
      }
    }
</style>
